export const CategoryProgressCard = ({
  categoryTypeProgressCount,
  categoryType
}: {
  categoryTypeProgressCount: number,
  categoryType: string
}) => (
  <div className="card bg-foreground rounded-md p-5 mr-5 w-56">
    <h3 className="text-primary font-semibold text-left text-3xl leading-8 mb-2">
      {categoryTypeProgressCount}
    </h3>
    <p className="font-medium text-left text-secondary">
      {categoryType}
    </p>
  </div>
)
